<template>
    <div id="dashboard">
        <v-row class="justify-center">
            <SesonOverView/> 
        </v-row>
    </div>
</template>

<script>
import SesonOverView from '@/components/SesonOverView'
export default {
    name:'dashboard',
    components:{
        SesonOverView
    },
    data(){
        return{

         }
    }
}
</script>